/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContactSearchResultDto } from '../models/ContactSearchResultDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PersonService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Search contacts (entities) with optional name, email, and phone filters.
     * Returns entity data enriched with Person email/phone from the Person table.
     * @param orgGuid
     * @param entityDefinitionGuid
     * @param nameSearch
     * @param emailSearch
     * @param phoneSearch
     * @param skip
     * @param take
     * @returns ContactSearchResultDto OK
     * @throws ApiError
     */
    public searchContacts(
        orgGuid: string,
        entityDefinitionGuid: string,
        nameSearch?: string,
        emailSearch?: string,
        phoneSearch?: string,
        skip?: number,
        take: number = 50,
    ): CancelablePromise<ContactSearchResultDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/Person/{orgGuid}/{entityDefinitionGuid}/SearchContacts',
            path: {
                'orgGuid': orgGuid,
                'entityDefinitionGuid': entityDefinitionGuid,
            },
            query: {
                'nameSearch': nameSearch,
                'emailSearch': emailSearch,
                'phoneSearch': phoneSearch,
                'skip': skip,
                'take': take,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
